export default __webpack_public_path__ + "assets/static/data/spyne-docs-data.132960a86c498ff08ed0a73bc0f936cb.json";